import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import ShowChartIcon from '@material-ui/icons/ShowChart'
import FavoriteIcon from '@material-ui/icons/Favorite'
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun'
import OpacityIcon from '@material-ui/icons/Opacity'
import WavesIcon from '@material-ui/icons/Waves'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import GarminSDK from './garminDashboard/GarminSDK'

class GarminSDKDashboard extends React.Component {
  state = { group: {} }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) this.setState({ group: data.data })
      else this.props.history.push('/groups')
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  componentDidMount() {
    this.getGroupData()
  }

  buildSecondaryNav() {
    const { match, location } = this.props
    const items = [
      { key: 'hrv', label: 'HRV', path: 'hrv', icon: <ShowChartIcon /> },
      { key: 'heart', label: '心率', path: 'heart', icon: <FavoriteIcon /> },
      { key: 'accelerometer', label: '加速度', path: 'accelerometer', icon: <DirectionsRunIcon /> },
      { key: 'spo2', label: '血氧', path: 'spo2', icon: <OpacityIcon /> },
      { key: 'respiration', label: '呼吸', path: 'respiration', icon: <WavesIcon /> },
    ]
    return items.map((item) => ({
      ...item,
      to: `${match.url}/${item.path}`,
      active: location.pathname.includes(`/${item.path}`),
    }))
  }

  render() {
    const { match } = this.props
    const uniqid = match.params.uniqid
    return (
      <AppShell
        uniqid={uniqid}
        title={`Garmin SDK · ${this.state.group.name || ''}`}
        subtitle={this.state.group.description}
        secondaryNav={this.buildSecondaryNav()}
      >
        <PageCard>
          <Route
            path={`${match.url}/hrv`}
            render={() => (
              <GarminSDK
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="hrv"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/heart`}
            render={() => (
              <GarminSDK search={this.props.location.search} resource="heart" uniqid={uniqid} />
            )}
          />
          <Route
            path={`${match.url}/accelerometer`}
            render={() => (
              <GarminSDK
                search={this.props.location.search}
                resource="accelerometer"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/spo2`}
            render={() => (
              <GarminSDK search={this.props.location.search} resource="spo2" uniqid={uniqid} />
            )}
          />
          <Route
            path={`${match.url}/respiration`}
            render={() => (
              <GarminSDK
                search={this.props.location.search}
                resource="respiration"
                uniqid={uniqid}
              />
            )}
          />
        </PageCard>
      </AppShell>
    )
  }
}

GarminSDKDashboard.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default GarminSDKDashboard
